/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgCaseStudy = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "m55.41 22.59-16-16L38 6H18l-2 2v8h4v-6h16v14l2 2h14v28H20v-6h-4v8l2 2h36l2-2V24l-.59-1.41ZM40 22v-9.16l4.58 4.58L49.17 22H40Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m26.26 41.79 8.83 8 2.69-3-8.83-8a12.53 12.53 0 1 0-2.69 2.95v.05ZM10 32a8.5 8.5 0 1 1 8.5 8.5A8.51 8.51 0 0 1 10 32Z"
}));

export default SvgCaseStudy;